// What a budget modal does after its submit: the tab decides (it owns the notifications, the refetches
// and the selection — docs/api-types/gpu-budgets.md "Errors"), the modal only displays.

export interface ModalFeedback {
  /** Close the modal (a success, or an error after which the modal's content is stale). */
  close: boolean;
  /** `data.<field>` of a field error; the modal shows its own fields under them, the rest in an Alert. */
  fieldErrors: Record<string, string>;
  /** A message for a danger Alert inside the modal (a cap, the "not available" message, a refusal). */
  alert: string | null;
}

export const CLOSE_MODAL: ModalFeedback = { close: true, fieldErrors: {}, alert: null };

/**
 * The field errors a modal has no field for (`body`, `kind`, `<key>: unknown field`), as Alert lines.
 * `body` and `kind` carry a full sentence; any other key is prefixed with its name.
 */
export function otherFieldErrors(fieldErrors: Record<string, string>, ownFields: readonly string[]): string[] {
  return Object.entries(fieldErrors)
    .filter(([field]) => !ownFields.includes(field))
    .map(([field, message]) => (field === 'body' || field === 'kind' ? message : `${field}: ${message}`));
}
